import React, { useState, useEffect, } from "react";
import { Box, Chip, Grid, MenuItem, TextField, Typography, Tooltip } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as patientActions from '../../redux/actions/patientActions';
import { store } from '../../redux/store/index';
import { socket } from "../../socket/socket";
import { API } from "../../api/api";
import {
    Button,
} from "@mui/material";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Dialog,
    IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import * as hospitalActions from '../../redux/actions/hospitalActions';
import { ReactComponent as Stethoscope } from '../../assets/stethoscope.svg';
import ChatIcon from '@mui/icons-material/Chat';
import LensIcon from '@mui/icons-material/Lens';
import * as patientAction from '../../redux/actions/patientActions';
import { ReactComponent as Male } from '../../assets/male.svg';
import { ReactComponent as Female } from '../../assets/woman.svg';
import { ReactComponent as Both } from '../../assets/Both.svg';

const boxContainer = {
    flex: 1, minHeight: 0, height: { xs: 'auto', md: '100%' }, overflow: { xs: 'visible', md: 'hidden' },
    '& .custom-scrollbars__container': {
        height: '100%'
    },
    '& .custom-scrollbars__content': {
        height: '100%',
        maxHeight: '100%'
    },
}

const gridContainer = {
    borderRadius: 4, display: 'flex', flexDirection: 'column', overflow: { xs: 'visible', md: 'hidden' }, marginBottom: '10px'
}

const frequencyOptions = ["Once", "Daily", "Several times a day", "Constant"];
const severityOptions = ['Mild', 'Moderate', 'Severe', 'Extremely severe'];

const ComplaintDetailCard = ({ complaint, patientId, onClose, isModal }) => {
    const patientReducer = useSelector((state) => state.patientReducer);
    const patientConditions = patientReducer?.patientInfo?.conditions || [];
    const isPreconception = patientConditions.some(c => c?.code === "PRECONCEPTION" || c?.name?.toUpperCase().includes("PRECONCEPTION"));

    console.log("complaint",complaint)
    const [frequency, setFrequency] = useState(complaint.frequency || "");
    const [severity, setSeverity] = useState(complaint.severity || "");
    const [remarks, setRemarks] = useState(complaint.remarks || "");
    const [status, setStatus] = useState(complaint.status || "ONGOING");
    const [memberRole, setMemberRole] = useState(complaint.memberRole || "");
    console.log("mem",memberRole)
    useEffect(() => {
        setFrequency(complaint.frequency || "");
        setSeverity(complaint.severity || "");
        setRemarks(complaint.remarks || "");
        setStatus(complaint.status || "ONGOING");
        setMemberRole(complaint.memberRole || "")
    }, [complaint]);

    const handleUpdate = () => {
        const { title, id, complaintId, isCreatedByPatient, periods, source, isConfirmed, isAcknowledgedByDoctor, ...dataUpdateRequest } = complaint;
        store.dispatch(patientActions.updateComplaintRequestAction(patientId, complaint.id, {
            ...dataUpdateRequest,
            frequency,
            severity,
            remarks,
            status,
            memberRole
        }));
        if (onClose) onClose();
    }

    return (
        <Box sx={isModal ? {} : { border: '1px solid #E5E7EB', borderRadius: 3, p: 2, mb: 2, backgroundColor: '#FFF', boxShadow: '0px 2px 4px rgba(0,0,0,0.02)' }}>
            <Box display="flex" flexWrap="wrap" mx={-1}>
                <Box px={1} mb={2} flex="1 1 200px">
                    <Typography fontSize="12px" fontWeight="600" color="#6B7280" mb={0.75}>Frequency</Typography>
                    <Box display="flex" flexWrap="wrap" gap={0.75}>
                        {frequencyOptions.map(opt => (
                            <Chip
                                key={opt}
                                label={opt}
                                size="small"
                                sx={{
                                    border: frequency === opt ? '1px solid #919191' : 'none',
                                    color: frequency === opt ? 'black' : '#333',
                                    fontWeight: frequency === opt ? 500 : 300,
                                    "&:hover": {
                                        backgroundColor: { md: '#F2F2F2', xs: 'transparent' },
                                    },
                                    fontSize: { xl: '14px', lg: '12px', md: '11px' },
                                    backgroundColor: 'transparent',
                                    borderRadius: 2,
                                }}
                                onClick={() => setFrequency(opt)}
                            />
                        ))}
                    </Box>
                </Box>
                <Box px={1} mb={2} flex="1 1 200px">
                    <Typography fontSize="12px" fontWeight="600" color="#6B7280" mb={0.75}>Severity</Typography>
                    <Box display="flex" flexWrap="wrap" gap={0.75}>
                        {severityOptions.map(opt => (
                            <Chip
                                key={opt}
                                label={opt}
                                size="small"
                                sx={{
                                    border: severity === opt ? '1px solid #919191' : 'none',
                                    color: severity === opt ? 'black' : '#333',
                                    fontWeight: severity === opt ? 500 : 300,
                                    "&:hover": {
                                        backgroundColor: { md: '#F2F2F2', xs: 'transparent' },
                                    },
                                    fontSize: { xl: '14px', lg: '12px', md: '11px' },
                                    backgroundColor: 'transparent',
                                    borderRadius: 2,
                                }}
                                onClick={() => setSeverity(opt)}
                            />
                        ))}
                    </Box>
                </Box>
                <Box px={1} mb={2} flex="1 1 150px">
                    <Typography fontSize="12px" fontWeight="600" color="#6B7280" mb={0.75}>Status</Typography>
                    <Box display="flex" flexWrap="wrap" gap={0.75}>
                        {["ONGOING", "ENDED"].map(opt => (
                            <Chip
                                key={opt}
                                label={opt === "ONGOING" ? "Ongoing" : "Ended"}
                                size="small"
                                sx={{
                                    border: status === opt ? '1px solid #919191' : 'none',
                                    color: status === opt ? 'black' : '#333',
                                    fontWeight: status === opt ? 500 : 300,
                                    "&:hover": {
                                        backgroundColor: { md: '#F2F2F2', xs: 'transparent' },
                                    },
                                    fontSize: { xl: '14px', lg: '12px', md: '11px' },
                                    backgroundColor: 'transparent',
                                    borderRadius: 2,
                                }}
                                onClick={() => setStatus(opt)}
                            />
                        ))}
                    </Box>
                </Box>
                {isPreconception && <Box px={1} mb={2} flex="1 1 150px">
                    <Typography fontSize="12px" fontWeight="600" color="#6B7280" mb={0.75}>Gender</Typography>
                    <Box display="flex" flexWrap="wrap" gap={0.75}>
                        {["HIM", "HER", "BOTH"].map(opt => (
                            <Chip
                                key={opt}
                                label={opt === "HER" ? "Her" : opt === "HIM" ? "Him" : "Both"}
                                size="small"
                                sx={{
                                    border: memberRole === opt ? '1px solid #919191' : 'none',
                                    color: memberRole === opt ? 'black' : '#333',
                                    fontWeight: memberRole === opt ? 500 : 300,
                                    "&:hover": {
                                        backgroundColor: { md: '#F2F2F2', xs: 'transparent' },
                                    },
                                    fontSize: { xl: '14px', lg: '12px', md: '11px' },
                                    backgroundColor: 'transparent',
                                    borderRadius: 2,
                                }}
                                onClick={() => setMemberRole(opt)}
                            />
                        ))}
                    </Box>
                </Box>}
                <Box px={1} flex="1 1 100%">
                    <Typography fontSize="12px" fontWeight="600" color="#6B7280" mb={0.75}>Remarks</Typography>
                    <TextField
                        fullWidth
                        size="small"
                        multiline
                        rows={2}
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                        placeholder="Add remarks..."
                        sx={{ backgroundColor: '#F9FAFB', '& .MuiOutlinedInput-root': { borderRadius: 2 }, '& .MuiInputBase-input': { fontSize: '13px', padding: '2px' } }}
                    />
                </Box>
            </Box>
            <Box display="flex" justifyContent={isModal ? "flex-end" : "space-between"} alignItems="center" mt={1}>
                {!isModal && <Typography fontWeight="600" fontSize="15px" color="#1F2937">{complaint.title}</Typography>}
                <Button variant="contained" size="small" sx={{ backgroundColor: '#F27704', textTransform: 'none', height: 28, px: 2, fontSize: '12px', borderRadius: 1.5, '&:hover': { backgroundColor: '#E66A00' }, boxShadow: 'none' }} onClick={handleUpdate}>Save Updates</Button>
            </Box>
        </Box>
    );
};

const CommonGate = ({ showComplaint, refreshHistory, refreshObervation }) => {
    const { patientId, consultationId } = useParams();
    const [complaints, setComplaints] = useState([]);
    const hospitalReducer = useSelector(state => state.hospitalReducer)
    const patientReducer = useSelector((state) => state.patientReducer);
    const [conditions, setConditions] = useState([])
    const [selectedSymptoms, setSelectedSymptoms] = useState([]);
    const [selectedSymptomIds, setSelectedSymptomIds] = useState([]);

    const STORAGE_KEY = consultationId ? `suggestedCodes_${consultationId}` : null;
    const [recommendedConditionCodes, setRecommendedConditionCodes] = useState(() => {
        if (!STORAGE_KEY) return [];
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            return stored ? JSON.parse(stored) : [];
        } catch {
            return [];
        }
    });

    const [selectedConditionIds, setSelectedConditionIds] = useState([]);
    const [selectedAlphabet, setSelectedAlphabet] = useState("POPULAR");
    const alphabets = [
        "POPULAR",
        ..."ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    ];
    const [capturedComplaints, setCapturedComplaints] = useState([]);
    const [selectedComplaintForEdit, setSelectedComplaintForEdit] = useState(null);
    const [complaintSearch, setComplaintSearch] = useState("");
    const [mode, setMode] = useState('view')
    const location = useLocation();
    const [chiefComplaintExpanded, setChiefComplaintExpanded] = useState(true);
    const [isJourneyEnabled, setIsJourneyEnabled] = useState(false);
    const [confirmingConditionId, setConfirmingConditionId] = useState(null);
    const [showAllConditions, setShowAllConditions] = useState(false);
    const dispatch = useDispatch();
    console.log("sleected",selectedComplaintForEdit)
    const prevStorageKeyRef = React.useRef(STORAGE_KEY);

    // Persist recommended codes across tab switches
    useEffect(() => {
        if (!STORAGE_KEY) return;
        if (prevStorageKeyRef.current !== STORAGE_KEY) return;
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(recommendedConditionCodes));
        } catch {
            // ignore storage errors
        }
    }, [recommendedConditionCodes, STORAGE_KEY]);

    // Reload recommended codes when consultation changes
    useEffect(() => {
        prevStorageKeyRef.current = STORAGE_KEY;
        // Reset local state when consultationId changes
        setSelectedConditionIds([]);
        setSelectedSymptoms([]);
        setSelectedSymptomIds([]);
        setRecommendedConditionCodes([]);
        
        if (!STORAGE_KEY) {
            setRecommendedConditionCodes([]);
            return;
        }
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            setRecommendedConditionCodes(stored ? JSON.parse(stored) : []);
        } catch {
            setRecommendedConditionCodes([]);
        }
    }, [STORAGE_KEY]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const mode = queryParams.get('mode');
        if (mode) {
            setMode(mode);
        }
    }, [location.search]);

    useEffect(() => {
        store.dispatch(hospitalActions.getComplaintsRequestAction())
    }, []);

    useEffect(() => {
        if (patientId) {
            store.dispatch(patientActions.getPatientComplaintsRequestAction(patientId, "ONGOING"))
            store.dispatch(patientActions.getPatientDetailsRequestAction(patientId, true));
        }
    }, [patientId]);

    useEffect(() => {
        const complaints = hospitalReducer.complaints || [];
        const combinedList = [
            ...complaints,
        ];
        setComplaints(combinedList);
    }, [hospitalReducer.complaints,])

    useEffect(() => {
        if (patientReducer?.patientInfo) {
            const selectedData = patientReducer?.patientInfo?.conditions.map(item => item.id);
            setSelectedConditionIds(selectedData)
        } else {
            setSelectedConditionIds([])
        }
    }, [patientReducer?.patientInfo])

    const getComplaints = async () => {
        try {
            store.dispatch(patientActions.getConditionRequestAction())
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getComplaints()
    }, [])

    useEffect(() => {
        if (!patientId) return;
        const handleCommandOutput = (data) => {
            console.log("data came on event", data)
            const [, , rawCardType] = data?.data?.originActionType?.split('.');

            let cardType = rawCardType;
            let cardKey = rawCardType;
            if (rawCardType.includes(':')) {
                const [cardCategory, id] = rawCardType.split(':');
                cardType = cardCategory
                cardKey = rawCardType
            }
            if (consultationId !== data?.data?.consultationId) {
                return
            }
            if (
                data?.actionType === "commandOutput.refreshWebDashboard"
            ) {
                console.log("cardType",cardType)
                if (cardType == "condition"||cardType == "conditions") {
                    getComplaints()
                    store.dispatch(patientActions.getPatientDetailsRequestAction(patientId, true));
                }
                if (cardType == "activeSymptoms") {
                    store.dispatch(patientActions.getPatientComplaintsRequestAction(patientId, "ONGOING"))
                }
            }
        };
        socket.on("commandOutput", handleCommandOutput);
    }, [patientId]);



    const latestRequestRef = React.useRef(0);

    const getRecommendedConditions = async (symptoms = []) => {
        const requestId = Date.now();
        latestRequestRef.current = requestId;
        try {
            if (!symptoms.length && !patientId) {
                setRecommendedConditionCodes([]);
                return;
            }

            const res = await API.post(
                "/v1/patients/recommended-conditions",
                {
                    symptoms,
                    patientId,
                    consultationId,
                }
            );
            if (latestRequestRef.current !== requestId) return;
            
            console.log("ddd", res)
            const rawData = res?.data ?? res;
            const list = Array.isArray(rawData)
                ? rawData
                : (Array.isArray(rawData?.recommended) ? rawData.recommended : []);
            const codes = list.map(item => item.code).filter(Boolean);

            setRecommendedConditionCodes(codes);
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        const ongoing = [
            ...(patientReducer?.ongoingComplaints || []),
        ];
        const complaintIds = ongoing.map(item => item.complaintId);
        const titles = ongoing.map(item => item.title);
        setSelectedSymptoms(titles)
        setSelectedSymptomIds(complaintIds)
        setCapturedComplaints(ongoing);
        getRecommendedConditions(titles);
    }, [
        patientReducer?.ongoingComplaints,
    ]);

    useEffect(() => {
        if (patientReducer?.complaintsWithCondition?.length > 0) {
            setConditions(patientReducer.complaintsWithCondition)
        }
    }, [patientReducer.complaintsWithCondition])

    useEffect(() => {
        if (patientReducer?.conditionCreated?.consultationId) {
            store.dispatch(patientActions.resetConditionCreation())
            store.dispatch(patientActions.getPatientDetailsRequestAction(patientId, true));
            dispatch(patientAction.getPatientComplaintsRequestAction(patientId, "ONGOING"))
        }
    }, [patientReducer?.conditionCreated])

    const saveConditions = async () => {
        const existingConditions =
            patientReducer?.patientInfo?.conditions || [];
        const removePatientConditionIds =
            existingConditions
                .filter(
                    item =>
                        !selectedConditionIds.includes(item.id)
                )
                .map(
                    item => item.patientConditionId
                );

        const payload = {
            "complaintIds": selectedSymptomIds,
            "conditionIds": selectedConditionIds
        }
        if (existingConditions.length === 0 || removePatientConditionIds.length == 0) {

            store.dispatch(
                patientActions.createConditionRequestAction(
                    consultationId,
                    payload
                )
            );

            setIsJourneyEnabled(false);
            if (refreshHistory) {
                refreshHistory()
            }
            if (refreshObervation) {
                setTimeout(() => {
                    window.location.reload()
                }, 3000);
            }
            return;
        }

        const previousIds =
            existingConditions.map(item => item.id);
        const addConditionIds =
            selectedConditionIds.filter(
                id => !previousIds.includes(id)
            );



        if (
            addConditionIds.length === 0 &&
            removePatientConditionIds.length === 0
        ) {
            return;
        }
        try {
            await API.patch(
                `/v1/consultations/${consultationId}/conditions`,
                {
                    addConditionIds,
                    removePatientConditionIds,
                }
            );
            store.dispatch(patientActions.getConditionTimelineRequestAction(patientId));
            store.dispatch(
                patientActions.getPatientDetailsRequestAction(
                    patientId, true
                )
            );
            if (refreshHistory) {
                refreshHistory()
            }
            if (refreshObervation) {
                setTimeout(() => {
                    window.location.reload()
                }, 3000);
            }
            dispatch(patientAction.getPatientComplaintsRequestAction(patientId, "ONGOING"))
            setIsJourneyEnabled(false);
        } catch (err) {
            console.log(err);
        }
    };

    const confirmCondition = async (conditionId, patientConditionsId) => {
        try {
            setConfirmingConditionId(conditionId);

            await API.post(
                `/v1/consultations/${consultationId}/conditions/confirm`,
                {
                    conditionIds: [patientConditionsId]
                    // patientConditionsId: [patientConditionsId]
                }
            );

            // Refresh patient data so isConfirmed becomes true
            store.dispatch(
                patientActions.getPatientDetailsRequestAction(patientId, true)
            );

            // Optional: refresh condition timeline
            store.dispatch(
                patientActions.getConditionTimelineRequestAction(patientId)
            );

        } catch (err) {
            console.log("Error confirming condition:", err);
        } finally {
            setConfirmingConditionId(null);
        }
    };

    const handleCreateComplaint = async () => {
        if (!complaintSearch.trim()) return;
        try {
            const endpoint = "/v1/hospitals/complaints";
            const response = await API.post(endpoint, {
                title: complaintSearch.trim(),
            });
            const createdItem = response?.data?.data || response?.data;
            if (createdItem) {
                setComplaints((prev) => [...prev, createdItem]);
                handleSymptomToggle(createdItem);
                setComplaintSearch("");
            }
        } catch (error) {
            console.error("Failed to create complaint", error);
        }
    };

    const handleSymptomToggle = async (symptom) => {
        let updatedSymptoms = [];
        let updatedIds = [];

        const alreadySelected = selectedSymptomIds.includes(symptom.id);

        if (alreadySelected) {
            updatedSymptoms = selectedSymptoms.filter(
                item => item !== symptom.title
            );

            updatedIds = selectedSymptomIds.filter(
                item => item !== symptom.id
            );
        } else {
            updatedSymptoms = [...selectedSymptoms, symptom.title];
            updatedIds = [...selectedSymptomIds, symptom.id];
        }

        setSelectedSymptoms(updatedSymptoms);
        setSelectedSymptomIds(updatedIds);
        setIsJourneyEnabled(true);
        getRecommendedConditions(updatedSymptoms);
    };

    const directUpdateCondition = async (conditionId, action, patientConditionId = null) => {
        try {
            const addConditionIds = action === 'add' ? [conditionId] : [];
            const removePatientConditionIds = action === 'remove' && patientConditionId ? [patientConditionId] : [];

            const existingConditions = patientReducer?.patientInfo?.conditions || [];

            if (existingConditions.length === 0 && action === 'add') {
                const payload = {
                    "complaintIds": selectedSymptomIds,
                    "conditionIds": [...selectedConditionIds, conditionId]
                };
                store.dispatch(
                    patientActions.createConditionRequestAction(
                        consultationId,
                        payload
                    )
                );
            } else {
                await API.patch(
                    `/v1/consultations/${consultationId}/conditions`,
                    {
                        addConditionIds,
                        removePatientConditionIds,
                    }
                );
            }

            store.dispatch(patientActions.getConditionTimelineRequestAction(patientId));
            store.dispatch(patientActions.getPatientDetailsRequestAction(patientId, true));

            if (refreshHistory) refreshHistory();
            if (refreshObervation) {
                // setTimeout(() => window.location.reload(), 3000);
                store.dispatch(patientActions.getPatientConsultationDetailsRequestAction(consultationId));
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleConditionToggle = (condition) => {
        const isSelected = selectedConditionIds.includes(condition.id);

        if (!showComplaint) {
            if (isSelected) {
                directUpdateCondition(condition.id, 'remove', condition.patientConditionId);
            } else {
                directUpdateCondition(condition.id, 'add');
            }
        } else {
            if (isSelected) {
                setSelectedConditionIds(prev =>
                    prev.filter(id => id !== condition.id)
                );
            } else {
                setSelectedConditionIds(prev => [
                    ...prev,
                    condition.id,
                ]);
            }
            setIsJourneyEnabled(true);
        }
    };

    const patientConditions = patientReducer?.patientInfo?.conditions || [];
    const isPreconception = patientConditions.some(c => c?.code === "PRECONCEPTION" || c?.name?.toUpperCase().includes("PRECONCEPTION"));

    const displayConditions = conditions
        .map(condition => {
            const patientCondition = patientConditions.find(
                item => item.id === condition.id
            );

            return {
                ...condition,
                ...(patientCondition || {}),
            };
        })
        .sort((a, b) => {
            const aSelected = selectedConditionIds.includes(a.id);
            const bSelected = selectedConditionIds.includes(b.id);
            const aSuggested = recommendedConditionCodes.includes(a.code);
            const bSuggested = recommendedConditionCodes.includes(b.code);

            if (aSelected && !bSelected) return -1;
            if (!aSelected && bSelected) return 1;
            if (aSuggested && !bSuggested) return -1;
            if (!aSuggested && bSuggested) return 1;

            return 0;
        });

    const selectedDisplayConditions = displayConditions.filter(condition =>
        selectedConditionIds.includes(condition.id) || recommendedConditionCodes.includes(condition.code)
    );

    const renderGate = () => {

        return <Grid size={{ xs: 12, md: 12 }} sx={{ ...gridContainer, mt: 1, border: "1px dashed #F56423", backgroundColor: '#FFF5EE' }}>
            <Box sx={boxContainer}>
                <Grid item sx={{}}>
                    <Grid container sx={{ p: 1, flexDirection: 'column' }}>
                        <Grid
                            container
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{ width: '100%', }}
                        >
                            <Box sx={{ flexDirection: 'row', display: 'flex', }}>
                                <Stethoscope />
                                <Typography variant="h6" fontWeight={!showComplaint ? "400" : "bold"} fontSize={"17px"} sx={{ fontSize: { xl: !showComplaint ? '15px' : '17px', lg: !showComplaint ? '14px' : '16px', md: !showComplaint ? '12px' : '13px', xs: !showComplaint ? '13px' : '14px' }, marginLeft: '4px' }}>
                                    Conditions Under Review
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                <LensIcon
                                    sx={{ color: "green", fontSize: '13px', ml: '4px', }}
                                />
                                <Typography fontWeight={"400"} sx={{ fontSize: { xl: '14px', lg: '13px', md: '13px', xs: '13px' }, marginLeft: '4px' }}>
                                    Confirmed
                                </Typography>
                                <LensIcon
                                    sx={{ color: "#E65100", fontSize: '13px', ml: '4px', }}
                                />
                                <Typography fontWeight={"400"} sx={{ fontSize: { xl: '14px', lg: '13px', md: '13px', xs: '13px' }, marginLeft: '4px' }}>
                                    Unconfirmed
                                </Typography>
                            </Box>
                        </Grid>

                        <Box display="flex" flexWrap="wrap" gap={1} mt={1}>
                            {(showComplaint ? displayConditions : selectedDisplayConditions).map(condition => {
                                const suggested = recommendedConditionCodes.includes(condition.code);
                                const selected = selectedConditionIds.includes(condition.id)
                                const isUnconfirmed = condition.isConfirmed !== true;
                                const isConfirming = confirmingConditionId === condition.id;

                                return <Box
                                    key={condition.id}
                                    onClick={() => handleConditionToggle(condition)}
                                    sx={{
                                        border: (suggested && !selected)
                                            ? "2px dashed #F56423"
                                            : selected ? '1px solid #919191' : 'transparent',

                                        borderRadius: 2,
                                        cursor: "pointer",
                                        p: 0.6,
                                        position: "relative",
                                        flexDirection: 'row', display: 'flex',
                                        alignItems: 'center'
                                    }}
                                >
                                    <Typography sx={{
                                        fontSize: { xl: '14px', lg: '12px', md: '11px' },
                                        cursor: "pointer",
                                    }}>
                                        {condition.name}
                                    </Typography>
                                    {suggested && !selected && (
                                        <Chip
                                            label="Suggested"
                                            color="success"
                                            size="small"
                                            sx={{
                                                ml: '4px',
                                                backgroundColor: "#F56423",
                                                color: '#FFF'
                                            }}
                                        />
                                    )}

                                    {/* Unconfirmed */}
                                    {isUnconfirmed && selected && (
                                        <>
                                            <LensIcon
                                                sx={{ color: "#E65100", fontSize: '13px', ml: '4px', }}
                                            />

                                            {condition.patientConditionId && (
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    disabled={isConfirming}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        confirmCondition(condition.id, condition.patientConditionId);
                                                    }}
                                                    sx={{
                                                        minWidth: 'auto',
                                                        px: 1,
                                                        py: 0.2,
                                                        height: 26,
                                                        borderRadius: 1.5,
                                                        textTransform: 'none',
                                                        fontSize: '11px',
                                                        fontWeight: 600,
                                                        ml: '4px',
                                                    }}
                                                >
                                                    {isConfirming ? 'Confirming...' : 'Confirm'}
                                                </Button>
                                            )}
                                        </>
                                    )}

                                    {/* Confirmed */}
                                    {condition.isConfirmed === true && (
                                        <LensIcon
                                            sx={{ color: "green", fontSize: '13px', ml: '4px', }}
                                        />
                                    )}
                                </Box>
                            })}
                            {!showComplaint && conditions.length > 0 && (
                                <TextField
                                    select
                                    size="small"
                                    value=""
                                    SelectProps={{
                                        displayEmpty: true,
                                    }}
                                    onChange={(e) => {
                                        const conditionId = e.target.value;

                                        if (!conditionId) return;

                                        if (!showComplaint) {
                                            directUpdateCondition(conditionId, 'add');
                                        } else {
                                            setSelectedConditionIds(prev => [
                                                ...prev,
                                                conditionId
                                            ]);
                                            setIsJourneyEnabled(true);
                                        }
                                    }}
                                    sx={{
                                        minWidth: 120,
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: 2,
                                            // backgroundColor: '#FFF',
                                        },
                                        '& .MuiSelect-select': {
                                            fontSize: '12px',
                                            fontWeight: 600,
                                        },
                                    }}
                                >
                                    <MenuItem value="" disabled >
                                        <Typography sx={{ fontSize: { xl: '12px', lg: '11px', md: '11px' }, }}>
                                            + Add More
                                        </Typography>
                                    </MenuItem>

                                    {displayConditions
                                        .filter(condition =>
                                            !selectedConditionIds.includes(condition.id)
                                        )
                                        .map(condition => (
                                            <MenuItem
                                                key={condition.id}
                                                value={condition.id}
                                            >
                                                {condition.name}
                                            </MenuItem>
                                        ))}
                                </TextField>
                            )}
                        </Box>
                        {isJourneyEnabled && <Button
                            variant="contained"
                            // disabled={(selectedConditionIds.length == 0)}
                            disabled={!isJourneyEnabled}
                            onClick={saveConditions}
                            sx={{
                                alignSelf: 'flex-start',
                                display: 'flex',
                                marginTop: '10px',
                                backgroundColor: '#FFF',
                                color: '#808080',
                                fontWeight: 'bold',
                                borderRadius: '10px',
                                textTransform: 'none',
                            }}
                        >
                            Continue
                        </Button>}
                    </Grid>

                </Grid>
            </Box>
        </Grid>
    }

    const sortedComplaints = [...complaints].sort((a, b) =>
        (a.title || "").localeCompare(b.title || "")
    );

    const searchTerm = complaintSearch.trim().toLowerCase();

    const filteredComplaints = sortedComplaints.filter((item) => {
        if (searchTerm && searchTerm.length > 2) {
            // Search entire complaint list
            return (item.title || "").toLowerCase().includes(searchTerm);
        }

        if (selectedAlphabet === "POPULAR") {
            return item.isPopular || selectedSymptomIds.includes(item.id);
        }

        // alphabet filter only when search is empty
        return (item.title || "")
            .toUpperCase()
            .startsWith(selectedAlphabet);
    });

    const renderChiefComplaints = () => {
        return <Accordion
            expanded={chiefComplaintExpanded}
            onChange={(_, expanded) => setChiefComplaintExpanded(expanded)}
            disableGutters
            elevation={0}
            sx={{
                borderRadius: "20px",
                border: "1px solid #E5E7EB",
                // backgroundColor: 'rgba(238, 251, 255, 0.3)',
                // boxShadow: '0px 4px 4px rgba(0,0,0,0.10)',
                mt: 0.5,
                "&:before": {
                    display: "none",
                },
                "&.Mui-expanded": {
                    margin: 0,
                },
            }}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                    minHeight: "unset",
                    px: 1,
                    py: 1,
                    "&.Mui-expanded": {
                        minHeight: "unset",
                    },
                    "& .MuiAccordionSummary-content": {
                        margin: 0,
                        padding: 0,
                    },
                    "& .MuiAccordionSummary-content.Mui-expanded": {
                        margin: 0,
                    },
                }}
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    gap={0.5}
                >
                    <Box sx={{ flexDirection: 'row', display: 'flex' }}>
                        <ChatIcon />
                        <Typography fontWeight="bold" fontSize={"17px"} sx={{ fontSize: { xl: '17px', lg: '16px', md: '13px', xs: '14px' }, marginLeft: '4px' }}>
                            Her Voice
                        </Typography>
                    </Box>

                    <Typography
                        fontWeight={300}
                        fontSize="14px"
                    >
                        What she's telling us — captured today by typing; ready for voice capture later.
                    </Typography>

                    {capturedComplaints.length > 0 && <Typography
                        fontWeight={600}
                        fontSize="13px"
                    >
                        Captured Complaints:
                    </Typography>}
                    {capturedComplaints.length > 0 && <Box display="flex" flexWrap="wrap" gap={1}>
                        {capturedComplaints.map(item => {
                            return (
                                <Tooltip
                                    key={item.id}
                                    arrow
                                    placement="top"
                                    title={
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, px: 0.5, py: 0.5, fontSize: '12px' }}>
                                            {item.frequency && <div><b>Frequency:</b> {item.frequency}</div>}
                                            {item.severity && <div><b>Severity:</b> {item.severity}</div>}
                                            {item.status && <div><b>Status:</b> {item.status}</div>}
                                            {(isPreconception && item.memberRole) && <div><b>Gender:</b> {item.memberRole}</div>}
                                            {item.remarks && <div><b>Remarks:</b> {item.remarks}</div>}
                                            {!item.frequency && !item.severity && !item.status && !item.remarks && <div>No additional details captured</div>}
                                        </Box>
                                    }
                                >
                                    <Box
                                        onClick={(e) => e.stopPropagation()}
                                        sx={{
                                            border: '1px solid #919191',
                                            borderRadius: 2,
                                            px: 0.5,
                                            py: 0.5,
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 0.5,
                                            cursor: 'default'
                                        }}
                                    >
                                        <Typography fontSize={13} fontWeight={500}>
                                            {item.title}
                                        </Typography>

                                        {isPreconception && item.memberRole == 'HIM' && (
                                            <Male width={12} height={12} />
                                        )}

                                        {isPreconception && item.memberRole == 'HER' && (
                                            <Female width={12} height={12} />
                                        )}

                                        {isPreconception && item.memberRole == 'BOTH' && (
                                           <>
                                            <Male width={12} height={12} />
                                            <Female width={12} height={12} />
                                            </>
                                        )}

                                        {item.isCreatedByPatient && (
                                            <Chip
                                                size="small"
                                                label="Mother"
                                                sx={{
                                                    bgcolor: "#E3F2FD",
                                                    color: "#1565C0",
                                                    height: 20,
                                                    fontSize: 10,
                                                }}
                                            />
                                        )}

                                        {item.isAcknowledgedByDoctor && (
                                            <Chip
                                                size="small"
                                                label="Doctor"
                                                sx={{
                                                    bgcolor: "#E8F5E9",
                                                    color: "#2E7D32",
                                                    height: 20,
                                                    fontSize: 10,
                                                }}
                                            />
                                        )}

                                        {(mode !== "view" && item.isAcknowledgedByDoctor) && (
                                            <IconButton size="small" onClick={(e) => {
                                                e.stopPropagation();
                                                setSelectedComplaintForEdit(item);
                                            }} sx={{ p: 0.25, ml: 0.5 }}>
                                                <Typography sx={{ fontSize: '9px', cursor: 'pointer' }}>edit</Typography>
                                            </IconButton>
                                        )}
                                        {(mode !== "view" && item.isCreatedByPatient) && (
                                            <IconButton size="small" onClick={(e) => {
                                                e.stopPropagation();
                                                store.dispatch(patientActions.updateComplaintRequestAction(patientId, item.id, {
                                                    isAcknowledgedByDoctor: true
                                                }));
                                            }} sx={{}}>
                                                <Typography sx={{ fontSize: '9px', cursor: 'pointer' }}>confirm</Typography>
                                            </IconButton>
                                        )}
                                    </Box>
                                </Tooltip>
                            );
                        })}

                    </Box>}
                </Box>
            </AccordionSummary>
            {mode !== "view" && <AccordionDetails
                sx={{
                    px: 1,
                    pt: 0,
                    pb: 1.5,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 1,
                        mt: 1,
                    }}
                >
                    {alphabets.map((letter) => (
                        <Chip
                            key={letter}
                            label={letter}
                            clickable
                            sx={{
                                backgroundColor: selectedAlphabet === letter
                                    ? "#E5E4E2"
                                    : '#FFF',
                                fontSize: '12px'
                            }}
                            onClick={() => setSelectedAlphabet(letter)}
                        />
                    ))}
                    <TextField
                        size="small"
                        placeholder="Search complaints..."
                        value={complaintSearch}
                        onChange={(e) => setComplaintSearch(e.target.value)}
                    />
                </Box>
                <Typography
                    sx={{ textAlign: 'left', textTransform: 'uppercase', color: 'grey' }}
                    mb={1}
                    fontWeight={400}
                    fontSize="14px"
                >
                    Select any new symptoms reported
                </Typography>

                <Box display="flex" flexWrap="wrap" gap={1}>
                    {filteredComplaints.length > 0 ? filteredComplaints.map(item => {
                        const isSelected = selectedSymptomIds.includes(item.id)
                        return <Chip
                            key={item.id}
                            label={item.title}
                            clickable
                            onClick={() => handleSymptomToggle(item)}
                            sx={{
                                border: isSelected ? '1px solid #919191' : 'none',
                                color: isSelected ? 'black' : '#333',
                                fontWeight: isSelected ? 500 : 300,
                                "&:hover": {
                                    backgroundColor: { md: '#F2F2F2', xs: 'transparent' },
                                },
                                fontSize: { xl: '14px', lg: '12px', md: '11px' },
                                backgroundColor: 'transparent',
                                borderRadius: 2,
                            }}
                        />
                    }) :
                        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", py: 1 }}>
                            <Typography sx={{ color: 'grey', mb: 1 }}>
                                No Symptom found.
                            </Typography>
                            {complaintSearch.trim() && (
                                <Button 
                                    variant="outlined" 
                                    size="small" 
                                    onClick={handleCreateComplaint}
                                    sx={{ textTransform: "none", borderRadius: "8px" }}
                                >
                                    Create "{complaintSearch}"
                                </Button>
                            )}
                        </Box>
                    }
                </Box>
            </AccordionDetails>}
        </Accordion>
    }

    return (<>
        {showComplaint && renderChiefComplaints()}
        {mode !== "view" && renderGate()}

        <Dialog open={!!selectedComplaintForEdit} onClose={() => setSelectedComplaintForEdit(null)} maxWidth="sm" fullWidth PaperProps={{
            sx: {
                borderRadius: '10px',
            },
        }}>
            {selectedComplaintForEdit && (
                <Box sx={{ p: 0, m: 0 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" px={2} pt={2} pb={1} borderBottom="1px solid #E5E7EB">
                        <Typography fontWeight="600" fontSize="16px">{selectedComplaintForEdit.title}</Typography>
                        <IconButton onClick={() => setSelectedComplaintForEdit(null)} size="small">
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Box p={2}>
                        <ComplaintDetailCard
                            complaint={selectedComplaintForEdit}
                            patientId={patientId}
                            onClose={() => setSelectedComplaintForEdit(null)}
                            isModal={true}
                        />
                    </Box>
                </Box>
            )}
        </Dialog>
    </>
    );
};

export default CommonGate;
